<script>
	// Constants
	import { PromotionsType } from '@/Constants/Promotions';
	// Stores
	import ACLStore from '@/Stores/ACLStore.js';
	// Partials
	import List from '@/Partials/Promotions/_List.svelte';
	import UpdatePromotion from '@/Partials/Promotions/_Update.svelte';
	import CreateNextDepositMatchPromotions from '@/Partials/Promotions/_Create.svelte';

	let createNewPromotion = false;
	let updatePromotion = false;
	let selectedPromotion = null;

	let listComponent;
</script>

<div>
	<div class="flex justify-end items-center w-full">
		<button
			on:click={() => (createNewPromotion = true)}
			class="btn {!($ACLStore && ACLStore.granted('promotions.create'))
				? 'btn-primary-action-disabled'
				: 'btn-primary'}"
			disabled={!($ACLStore && ACLStore.granted('promotions.create'))}
		>
			Create new deposit promotion
		</button>
	</div>
	<div class="flex">
		<List
			bind:selectedPromotion
			promotionType={PromotionsType.NextDepositMatch}
			bind:this={listComponent}
			on:selected={() => {
				updatePromotion = true;
			}}
		/>
	</div>
</div>

<CreateNextDepositMatchPromotions
	bind:open={createNewPromotion}
	type={PromotionsType.NextDepositMatch}
	on:created={listComponent.getPromotions()}
/>
{#if updatePromotion}
	<UpdatePromotion
		bind:open={updatePromotion}
		promotion={selectedPromotion}
		on:updated={listComponent.getPromotions()}
	/>
{/if}
